import { useState } from "react";
import { formatPhoneDisplay } from "@/lib/contact-info";

type PhoneInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "value"> & {
  label: string;
};

/**
 * Phone form field that live-formats what the user types into the site's
 * canonical display format, e.g. `(907) 312-1019`.
 */
export function PhoneField({ label, onChange, defaultValue, ...rest }: PhoneInputProps) {
  const [value, setValue] = useState(
    typeof defaultValue === "string" ? formatPhoneDisplay(defaultValue) : "",
  );

  return (
    <label className="grid gap-1.5">
      <span className="text-sm font-medium">{label}</span>
      <input
        {...rest}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        placeholder="(907) 312-1019"
        value={value}
        onChange={(e) => {
          e.target.value = formatPhoneDisplay(e.target.value);
          setValue(e.target.value);
          onChange?.(e);
        }}
        className="rounded-md border border-input bg-background px-3 py-2"
      />
    </label>
  );
}
